import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { BsTrash } from "react-icons/bs";
import Swal from "sweetalert2";
import swalWithBootstrapButtons from "sweetalert2-react-content";
import LoadingPageSm from "../../CommonComponent/LoadingPageSm";
import InputLebelComponent from "../../InputLebel/InputLebelComponent";
import removeCertificate from "../../../apis/removeCertificate";
import addCertificate from "../../../apis/addCertificate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const CertificationSetV2 = ({ resourceSlug, certificationDetails }) => {
  const MySwal = swalWithBootstrapButtons(Swal);

  const [isLoading, setIsLoading] = useState(true);
  const [certificateSet, setCertificateSet] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [crtText, setCrtText] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    setCertificateSet(certificationDetails || []);
    setIsLoading(false);
  }, [certificationDetails]);

  const handleAddNewCrt = () => {
    if (!crtText.trim()) {
      toast.error("Please enter certification name");
      return;
    }

    setIsProcessing(true);
    addCertificate(resourceSlug, crtText)
      .then((res) => {
        if (res?.data?.status && res?.data?.crt) {
          setCertificateSet((prev) => [...prev, res.data.crt]);
          setCrtText("");
          toast.success(res.data.message);
        } else {
          toast.warning(res?.data?.message || "Failed to add certification");
        }
      })
      .catch(console.error)
      .finally(() => setIsProcessing(false));
  };

  const confirmRemove = (id, title) => {
    MySwal.fire({
      title: "Are you sure?",
      text: `That you want to remove "${title}"`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      confirmButtonColor: "var(--danger)",
      cancelButtonColor: "var(--black)",
    }).then((result) => {
      if (result.isConfirmed) {
        processRemove(id);
      }
    });
  };

  const processRemove = (id) => {
    setIsProcessing(true);
    removeCertificate(resourceSlug, id)
      .then((res) => {
        if (res?.data?.status) {
          setCertificateSet((prev) =>
            prev.filter((crt) => crt.certification_id !== id)
          );
          toast.success(res.data.message);
        } else {
          toast.warning(res?.data?.message || "Unable to remove");
        }
      })
      .catch(console.error)
      .finally(() => setIsProcessing(false));
  };

  const renderCertificationBadges = () => {
    if (certificateSet.length === 0) {
      return <small className="text-muted">Nothing to display here!</small>;
    }

    return certificateSet.slice(0, 5).map((item) => (
      <span
        key={item.certification_id}
        className="badge-gray  text-sm"
        title={item.certification_title}
      >
        {item.certification_title.length > 20
          ? `${item.certification_title.slice(0, 20)}...`
          : item.certification_title}
      </span>
    ));
  };

  const displayAllCertificatesEditable = () => (
    <>
      <h6 className="fw-bold">Current Certifications</h6>
      <div className="d-flex flex-wrap">
        {certificateSet.length ? (
          certificateSet.map((item) => (
            <div
              key={item.certification_id}
              className="badge-gray cursor-pointer"
              disabled={isProcessing}
              onClick={() =>
                confirmRemove(
                  item.certification_id,
                  item.certification_title.replace(/[^a-zA-Z0-9 ]/g, "")
                )
              }
            >
              <span>
                {item.certification_title.replace(/[^a-zA-Z0-9 ]/g, "")}
              </span>
              <BsTrash className="text-danger ms-2" />
            </div>
          ))
        ) : (
          <small className="text-muted">Nothing to display here!</small>
        )}
      </div>
    </>
  );

  const renderModal = () => (
    <Modal
      show={showEdit}
      onHide={() => setShowEdit(false)}
      centered
      scrollable
      backdrop="static"
    >
      <Modal.Header>
        {/* No close icon */}
        <span className="fw-bold">Update Certifications</span>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-3">
          <div className="col-8">
            <InputLebelComponent title="Certification Name" />
            <input
              type="text"
              className="form-control"
              placeholder="Enter certification name"
              value={crtText}
              onChange={(e) => setCrtText(e.target.value)}
              disabled={isProcessing}
            />
          </div>
          <div className="col-4 d-flex align-items-end">
            <Button
              variant="success"
              className="w-100"
              onClick={handleAddNewCrt}
              disabled={isProcessing}
            >
              Add
            </Button>
          </div>
        </div>

        <hr />
        {displayAllCertificatesEditable()}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setShowEdit(false)}
          size="sm"
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h6 className="mb-0">My Certifications</h6>
        <FontAwesomeIcon
          icon={faEdit}
          className="text-primary cursor-pointer"
          title="Edit Certifications"
          role="button"
          onClick={() => setShowEdit(true)}
        />
      </div>

      {isLoading ? <LoadingPageSm /> : renderCertificationBadges()}

      {renderModal()}
    </>
  );
};

export default CertificationSetV2;
